export const MAX_SIZE_FILE_IN_BYTES = 20971520; // 20mb;
export const ALLOWED_EXTENSIONS = ['.pdf', '.jpeg', '.jpg', '.png'];
